// helper functions

export const isPagesPlatformPage = pagesNamesPath => pagesNamesPath.includes("/pages/")
export const isPagesPlatformContentPage = pagesNamesPath =>
  pagesNamesPath.includes("/pages/content/")
export const isPagesInvitePage = pagesNamesPath => pagesNamesPath.includes("/pages/invite")
